import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import { formatDate } from "utils/DateUtils";

type IProps = {
	project: ProjectResponseResource;
};

export default function ProjectMetadata(props: IProps) {
	return (
		<div className={classes["root"]}>
			{props.project.publishedAt && (
				<div>
					<Typography type="span" weight="medium" size="small">
						{I18n.asset.pages.project.publication}&nbsp;
					</Typography>
					<Typography type="span" weight="medium" size="small" className={classes["value"]}>
						{formatDate(I18n.getLocale(), props.project.publishedAt)}
					</Typography>
				</div>
			)}
			<div>
				<Typography type="span" weight="medium" size="small">
					{I18n.asset.pages.project.theme}&nbsp;
				</Typography>
				<Typography type="span" weight="medium" size="small" className={classes["value"]}>
					{I18n.asset.enums.EProjectThemes[props.project.theme]}
				</Typography>
			</div>
			<div>
				<Typography type="span" weight="medium" size="small">
					{I18n.asset.pages.project.format}&nbsp;
				</Typography>
				<Typography type="span" weight="medium" size="small" className={classes["value"]}>
					{I18n.asset.enums.EProjectFormats[props.project.format]}
				</Typography>
			</div>
		</div>
	);
}
